// extracted by mini-css-extract-plugin
module.exports = {"chart_start_color":"#622aae","main_color":"#308cf6","success_color":"#3fd184","error_color":"#ff6e6e","gray_color":"#c2c2c2","modal_background":"white"};